/**
 * Display Module
 * 
 * Handles global display issues (i.e. fix-grids, adjust-font-sizes, fix-flikity issues, etc. )
 *
 * TODO
    handle ajax loads as well
    need to calculate the last item in the row more accurately
 */

$(function () {
    'use strict';

    if (window.pz === undefined) {
        window.pz = {};
    }

    pz.display = function () {

        var initModule = function () {

            // Fix Grids on load and window resize 
            // TODO handle ajax loads as well
            $(window).on("load", fixGrids);
            $(window).on("resize", fixGrids);

            // Fix flickity resize stutter on window resize
            $(window).on("resize", function () {
                //if ($('.js-flickity').length) {}
                //$('.js-flickity').flickity('resize');
            });

            // Adjust layout / font sizes based on container widths on window resize
            $(window).on("resize", function () {
                $('.js-selection-grid-item').each(function () {
                    if ($(this).width() <= 1024 / 3) {
                        $(this).find('.overlay').addClass('narrow');
                    } else {
                        $(this).find('.overlay').removeClass('narrow');
                    }
                });
            });
        };

        // Fix Grids
        // sets image-grid borders — only set borders on inside edges
        // TODO: need to calculate the last item in the row more accurately
        var fixGrids = function fixGrids() {

            // generate groups by their groupId set by elements using data-fix-grid or data-fg
            var groups = {};
            $('[data-fg], [data-fix-grid]').each(function () {
                var $this = $(this),
                    groupId = $this.attr('data-fg') || $this.attr('data-fix-grid');
                if (groupId in groups) {
                    groups[groupId] = groups[groupId].add($this);
                } else {
                    groups[groupId] = $this;
                }
            });

            // apply matchHeight to each group
            $.each(groups, function () {
                fixGridGroup(this);
            });
        };

        // Fix grid group
        var fixGridGroup = function fixGridGroup($group) {
            //console.log('fixGrids');
            var currentRowStart = 0,
                rowDivs = [],
                $this,
                topPosition = 0,
                containerWidth = $group.first().parent().width(),
                columnWidth = $group.first().outerWidth(),
                columnsPerRow = Math.round(containerWidth / columnWidth),
                index,
                currentColumn;

            $group.each(function () {

                $this = $(this);
                index = $this.index();
                topPosition = $this.position().top;
                currentColumn = index % columnsPerRow + 1;

                // Clear last column class
                $this.removeClass('last-column');

                // Last item in row. Add last column class (remove right border)
                if (currentColumn == columnsPerRow) {
                    $this.addClass('last-column');
                }

                if (currentRowStart != topPosition) {

                    // New row. Set the variables for the new row
                    rowDivs.length = 0; // empty the array
                    currentRowStart = topPosition;
                    rowDivs.push($this);
                } else {

                    // Another div on the current row.
                    rowDivs.push($this);
                }

                // Clear last row class
                $this.removeClass('last-row');

                // Last item. Do the last row.
                if ($this.index() == $group.length - 1) {
                    $.each(rowDivs, function () {
                        $(this).addClass('last-row');
                        //$(this).css({'border-bottom':'none'});
                    });
                }
            });
        };

        return {
            initModule: initModule
        };
    }();

    pz.display.initModule();
});